import { useState } from "react";
import { useTranslation } from "next-i18next";
import { cn } from "../../../../../lib/utils";

const ASSETS_PATH = "/landings/assets/images/products/hub-talentos";

const DEPOIMENTO_KEYS = ["item01", "item02", "item03", "item04", "item05"];

export default function DepoimentosSection() {
	const { t } = useTranslation();
	const [current, setCurrent] = useState(0);

	const depoimentos = DEPOIMENTO_KEYS.map((key) => ({
		quote: t(`products.hub-talentos.depoimentos.items.${key}.quote`),
		name: t(`products.hub-talentos.depoimentos.items.${key}.name`),
		role: t(`products.hub-talentos.depoimentos.items.${key}.role`),
	}));

	const depoimento = depoimentos[current];

	const handlePrev = () => {
		setCurrent(
			(prev) => (prev - 1 + depoimentos.length) % depoimentos.length
		);
	};

	const handleNext = () => {
		setCurrent((prev) => (prev + 1) % depoimentos.length);
	};

	return (
		<section className="bg-neutral-08">
			<div className="container-blog">
			<div
				className={cn(
					"flex flex-col",
					"gap-6",
					"tablet:flex-row tablet:gap-8",
					"laptop:gap-[56px]"
				)}
			>
				{/* Title with quote icon */}
				<div className="flex items-start gap-4 tablet:gap-4 laptop:gap-[32px] shrink-0">
					<img
						src={`${ASSETS_PATH}/icon-quotes.svg`}
						alt=""
						className="hidden tablet:block tablet:w-[75px] tablet:h-[64px] laptop:w-[113px] laptop:h-[96px] rotate-180"
					/>
					<h2
						className={cn(
							"text-vivid-02 m-0 text-center tablet:text-left",
							"text-[24px] leading-[32px]",
							"tablet:text-[24px] tablet:leading-[32px]",
							"laptop:text-[40px] laptop:leading-[48px]",
							"w-full tablet:w-auto"
						)}
					>
						<span className="font-normal text-vivid-02">
							{t("products.hub-talentos.depoimentos.title")}
						</span>
						<br />
						<span className="font-semibold text-vivid-02">
							{t("products.hub-talentos.depoimentos.titleHighlight")}
						</span>
					</h2>
				</div>

				{/* Quote card */}
				<div
					className={cn(
						"flex-1 bg-background-02 rounded-2xl flex flex-col gap-4 items-center",
						"p-5 tablet:p-6",
						"shadow-[0px_2px_4px_0px_rgba(0,0,0,0.25),0px_12px_6px_0px_rgba(0,0,0,0.15)]"
					)}
				>
					<p
						className={cn(
							"text-ds-brand-green-300 text-center m-0",
							"font-semibold",
							"text-base leading-7",
							"tablet:text-base tablet:leading-6 tablet:font-normal",
							"laptop:text-[20px] laptop:leading-[32px] laptop:font-semibold"
						)}
					>
						{depoimento.quote}
					</p>

					<div className="flex flex-col gap-1 items-center text-center">
						<p className="text-white font-semibold m-0 text-base tablet:text-base tablet:leading-6">
							{depoimento.name}
						</p>
						<p className="text-white m-0 text-sm tablet:text-sm tablet:leading-[18px] font-normal">
							{depoimento.role}
						</p>
					</div>

					{/* Navigation arrows */}
					<div className="flex items-center justify-center gap-2">
						<button
							onClick={handlePrev}
							className="w-6 h-6 rounded-full bg-ds-brand-green-900 flex items-center justify-center border-0 cursor-pointer p-1"
							aria-label="Anterior"
						>
							<svg
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
							>
								<path
									d="M10 4L6 8L10 12"
									stroke="#449818"
									strokeWidth="1.5"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</button>
						<button
							onClick={handleNext}
							className="w-6 h-6 rounded-full bg-vivid-02 flex items-center justify-center border-0 cursor-pointer p-1"
							aria-label="Próximo"
						>
							<svg
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
							>
								<path
									d="M6 4L10 8L6 12"
									stroke="#122b08"
									strokeWidth="1.5"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>

			{/* Bottom text */}
			<div
				className={cn(
					"text-center",
					"mt-8",
					"tablet:mt-10",
					"laptop:mt-[56px]"
				)}
			>
				<p
					className={cn(
						"text-white m-0 font-medium",
						"text-base leading-7",
						"tablet:text-sm tablet:leading-[22px]",
						"laptop:text-[20px] laptop:leading-[32px]"
					)}
				>
					<span className="text-white">
						{t("products.hub-talentos.depoimentos.bottomText")}{" "}
					</span>
					<span className="font-bold text-ds-brand-green-300">
						{t("products.hub-talentos.depoimentos.bottomTextHighlight")}
					</span>
				</p>
			</div>
			</div>
		</section>
	);
}
